import React, { useEffect, useState, useRef, useContext } from 'react';
import axiosInstance from './../axiosInstance';
import Logbook from './Logbook';
import MyUserContext from './../myUserContext';

const LogbookDropdown = ({ artId, userId, onClose, language, isOpen, initialLogbookDateTimes, initialArt }) => {
  const [artData, setArtData] = useState(initialArt || null);
  const [logbookDateTimes, setLogbookDateTimes] = useState(initialLogbookDateTimes || []);
  const [loading, setLoading] = useState(!initialLogbookDateTimes);
  const dropdownRef = useRef(null);

  console.log("initialLogbookDateTimes:", initialLogbookDateTimes);

  useEffect(() => {
    // alert(artId);
    // alert(initialLogbookDateTimes);
    // alert(!initialLogbookDateTimes);
    if (!initialLogbookDateTimes && !initialArt) {
      axiosInstance
        .get(`/arts/${artId}/`)
        .then((response) => {
          setArtData(response.data);
        })
        .catch((error) => {
          console.error(error);
        });

      const logbookUrl = userId 
        ? `/art/logbook/get?artId=${artId}&userId=${userId}` 
        : `/art/logbook/get?artId=${artId}`;
      
      axiosInstance
        .get(logbookUrl)
        .then((response) => {
          setLogbookDateTimes(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    } else {
      setArtData(initialArt);
      setLogbookDateTimes(initialLogbookDateTimes);
    }
  }, [artId, userId, initialLogbookDateTimes]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        event.type === "mousedown"
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    const preventParentInteraction = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        event.preventDefault(); // Prevent parent scrolling only if the event is outside the dropdown
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden'; // Prevent parent scrolling
      document.addEventListener('touchmove', preventParentInteraction, { passive: false });
      document.addEventListener('wheel', preventParentInteraction, { passive: false });
    }

    return () => {
      document.body.style.overflow = ''; // Restore parent scrolling
      document.removeEventListener('touchmove', preventParentInteraction);
      document.removeEventListener('wheel', preventParentInteraction);
    };
  }, [isOpen]);

  if (loading) {
    return null; // Render nothing while loading
  }

  if (!artData) {
    return <div>Error loading art data.</div>;
  }

  return (
    <div
      ref={dropdownRef}
      className="pb-20 md:pb-0 fixed inset-x-0 bottom-0 bg-[#5D6064] border-t border-gray-500 shadow-lg max-h-[75vh] overflow-y-auto z-50 w-full sm:max-h-[50vh]"
    >
      <div className="sticky top-0 z-10 bg-[#5D6064] text-center py-2">
        <img
          src="/drag_down_icon.png"
          alt="Drag Down Icon"
          className="w-6 h-6 mx-auto cursor-pointer"
          onClick={onClose}
        />
      </div>
      <div className="">
        <h2 className="text-center text-lg font-bold text-white">
          {language === "ru" ? "Журнал" : "Logbook"}
        </h2>
        <div className="flex justify-center my-2">
          <img
            className="object-cover rounded-lg max-w-[100px]"
            src={artData.thumbnailUrl}
            alt={artData.name || "Art Thumbnail"}
          />
        </div>
        <div className="flex justify-center">
          <Logbook
            initialDateTimes={logbookDateTimes}
            art={artData}
            language={language}
          />
        </div>
      </div>
    </div>
  );
};

export default LogbookDropdown;
